var module = angular.module('octopusApp.projects');

module.directive('azureServiceFabricSdkRequiredInfo', function () {
    return {
        restrict: 'E',
        replace: true,
        templateUrl:'areas/projects/views/azure_service_fabric_sdk_required_info.html'
    };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/directives/azure_service_fabric_sdk_required_info.js
// module id = 4830283034925256
// module chunks = 1